import styled, { css } from 'styled-components'

import { type BoxProps, Layout } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

type ProviderCardProps = BoxProps & {
  readonly filled?: boolean
}

export const ProviderCard = styled(Layout.Box).attrs({
  borderWidth: 'border-thin',
  borderRadius: 'border-radius-m',
  padding: 'spacing-6',
  role: 'button',
})<ProviderCardProps>`
  flex: 1;
  min-width: 200px;

  ${({ filled }) => {
    if (filled) {
      return css`
        --m-box-background-color: ${toCSSValue('color-background-primary')};
        --m-box-border-color: ${toCSSValue('color-border')};
      `
    }

    return css`
      border-style: dashed;
      --m-box-background-color: ${toCSSValue('color-background-secondary')};
      --m-box-border-color: ${toCSSValue('color-border-input')};
    `
  }}

  &:hover {
    --m-box-background-color: ${toCSSValue('color-background-tertiary')};
    cursor: pointer;
    border-style: solid;
  }
`
